export default __webpack_public_path__ + "static/media/Standard-SASS-Architecture.272324df.jpg";